import React from "react";
import { useNavigate } from "react-router-dom";
import URL_MAPPING from "../../routes/constants";
import { ArrowLeft, ArrowRight } from "lucide-react";
import logo from "../../assets/logo.svg";
import { useTranslation } from "react-i18next";

const HrServicesGuide: React.FC = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const lang = i18n.language || localStorage.getItem("lang") || "English";
  const isEnglish = lang === "en" || lang === "English" || (typeof lang === "string" && lang.startsWith("en"));
  const isRTL = !isEnglish;

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(URL_MAPPING.LOGIN);
    }
  };

  const publicUrl = process.env.PUBLIC_URL || "";
  const guideSrc = `${publicUrl}/hr-services-guide.html`;

  return (
    <div className="flex flex-col h-screen w-screen bg-gray-50 overflow-hidden font-sans">
      {/* Top Navigation Header */}
      <header className="h-16 bg-gradient-to-r from-[#007a99] via-[#00a8cc] to-[#6a1b9a] text-white px-4 md:px-8 flex items-center justify-between shadow-md z-10 shrink-0 border-b-4 border-[#00a8cc]">
        <div className="flex items-center gap-3">
          <button
            onClick={handleBack}
            type="button"
            className="flex items-center gap-2 bg-white/15 hover:bg-white/25 text-white px-3.5 py-1.5 rounded-full text-xs md:text-sm font-semibold transition-all border border-white/30 shadow-sm cursor-pointer"
            title={t("backToLogin", isEnglish ? "Back to Login" : "العودة لتسجيل الدخول")}
          >
            {isRTL ? <ArrowRight className="w-4 h-4" /> : <ArrowLeft className="w-4 h-4" />}
            <span>{t("backToLogin", isEnglish ? "Back to Login" : "العودة لتسجيل الدخول")}</span>
          </button>
          <div className="h-6 w-px bg-white/20 hidden sm:block" />
          <h1 className="text-sm md:text-lg font-bold tracking-wide">
            {t("hrServicesGuide", isEnglish ? "Berain HR Services Guide" : "دليل خدمات الموارد البشرية - شركة بيرين")}
          </h1>
        </div>
        <div className="flex items-center gap-3">
          <img src={logo} alt="Berain Logo" className="h-7 md:h-8 brightness-0 invert object-contain" />
        </div>
      </header>

      {/* Main Content Area (Embedded HTML Guide) */}
      <main className="flex-1 w-full h-full relative bg-gray-100">
        <iframe
          src={guideSrc}
          title="دليل خدمات الموارد البشرية"
          className="w-full h-full border-0"
        />
      </main>
    </div>
  );
};

export default HrServicesGuide;
